import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import DowntimeDashboardLayer from "../components/dashboards/DowntimeDashboardLayer";

const DowntimeDashboardPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Downtime Dashboard">
        <DowntimeDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default DowntimeDashboardPage;
